import { RateModelDto } from './ratemodeldto';
import { PaginationFeaturesDto } from './paginationfeaturesdto';

export class RateModelRequest {

    rateModelDto: RateModelDto = new RateModelDto();

    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}